export default __webpack_public_path__ + "static/media/Pratyush Agrawal.2ab1c24b.jpg";